module.exports = __webpack_public_path__ + "img/piscine.5662a8bf.jpg";